import { PhotoItemFactory } from './photoItemFactory';

import type { PhotoItemEntity, PhotoItemProps } from './photoItemEntity';
import type { PhotoItemIRepository } from './photoItemIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { PhotoItemJson } from '@/types/domain/photo/entities/photoItemEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

export class PhotoItemRepository extends AppsyncRepositoryPvt<
  PhotoItemEntity,
  PhotoItemProps,
  PhotoItemJson
> implements PhotoItemIRepository {
  private factory = new PhotoItemFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryPhotoPhotoItemEntity;
    return name;
  }

  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
